<template>
  <ion-button
    :="$attrs"
    mode="ios"
    color="light"
    fill="outline"
    size="small"
    class="uppercase --border-radius fz-12"
    @click="toggleFavourite(props.courseId, props.streamId, props.entityType)"
  >
    {{ followText }}
  </ion-button>
</template>

<script setup>
import { IonButton } from '@ionic/vue';
import { computed } from 'vue';
import useFavorites from '@/composables/useFavorites';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  courseId: {
    type: [String, Number],
    required: true,
  },
  streamId: {
    type: [String, Number],
    default: '',
  },
  entityType: {
    type: String,
    default: 'episode',
  },
});

const emit = defineEmits(['unfollow', 'follow']);

const { t } = useI18n();

const { isFavorite, toggleFavourite } = useFavorites();

const followText = computed(() =>
  isFavorite(props.courseId, props.streamId)
    ? t('following.unfollow')
    : t('following.follow'),
);
</script>

<style scoped>
ion-button {
  --padding-start: 16px;
  --padding-end: 16px;
}
</style>
